module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-06-0caff54dfdb89ba1a97c97745242d8c5.svg";